/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_arrow-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M25 7.656l-.72.688L13.407 19.25c-.297.242-.433.63-.347 1.004a1 1 0 001.752.402L24 11.47V41c-.004.36.184.695.496.88.313.18.695.18 1.008 0 .312-.185.5-.52.496-.88V11.47l9.188 9.186c.242.297.628.434 1.003.348a1.003 1.003 0 00.404-1.754L25.72 8.344z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/icon_arrow-up.js